module.exports = __webpack_public_path__ + "img/p13.1231aa74.png";